import { createElement, FC } from 'react';
import { clsx } from 'clsx';

import { TextProps } from './Text.shared';

import './Text.scss';

export const Text: FC<TextProps> = ({
  as = 'p',
  children,
  className,
  color,
  lineHeight,
  size,
  style = 'normal',
  testID,
  textDecoration,
  uppercase,
  weight = 'regular',
  width = 'fullWidth',
  wrap,
}) => {
  const testProp = testID ? { 'data-test': testID } : null;
  const lineHeightProp = lineHeight ? { lineHeight: `${lineHeight}rem` } : {};

  return createElement(
    as,
    {
      ...testProp,
      className: clsx('text', size, weight, style, className, textDecoration, width, { uppercase, wrap }),
      style: { color: color, ...lineHeightProp },
    },
    children,
  );
};
